import {useState, useEffect, Fragment} from "react";
import {MIN_DESKTOP_SIZE} from "@/constants/general-constants";

export default function DesktopSize({children}) {

    const [isDesktop, setIsDesktop] = useState(false);
    const [initial, setInitial] = useState(false);

    useEffect(() => {
        if (!initial) {
            handleWindowSizeChange();
            setInitial(true);
        }

        window.removeEventListener('resize', handleWindowSizeChange);
        window.addEventListener('resize', handleWindowSizeChange);

        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, [isDesktop]); // eslint-disable-line

    const handleWindowSizeChange = () => {
        if (!isDesktop && screen.width >= MIN_DESKTOP_SIZE) {
            setIsDesktop(true);
        } else if (isDesktop && screen.width < MIN_DESKTOP_SIZE) {
            setIsDesktop(false);
        }
    }

    return (
        <Fragment>
            {
                isDesktop ? children : null
            }
        </Fragment>
    )

}
